<template>
  <div ref="head-container" class="head-container">
    <div v-if="$store.state.app.device == 'desktop'">
      <el-row
        class="head-row"
        type="flex"
        justify="space-between"
        style="margin: 0 50px"
      >
        <el-col :span="5" style="width: 20%">
          <img
            src="../assets/images/logo.png"
            class="logo"
            @click="$router.push({ path: '/' })"
          />
        </el-col>

        <el-col :span="14">
          <el-row
            v-if="
              this.$route.path !== '/login' &&
              this.$route.path !== '/register' &&
              this.$route.path !== '/forestPwd'
            "
          >
            <el-col
              :md="3"
              style="width: 10.5%"
              :span="2"
              v-for="(item, index) in menuList"
              :key="index"
            >
              <div
                @click="handleMenuClick(item, index)"
                @mouseenter="handleMenuEnter(item, index)"
                @mouseleave="handleMenuLeave(item)"
                style="text-align: center;"
              >
                <span
                  class="text"
                  :style="{
                    color: curIndex == index ? '#D7000F' : '#000000',
                    fontSize: '14px',
                  }"
                  >{{ item.name }}</span
                >
                <i
                  class="el-icon-arrow-down"
                  v-if="(item.isDropdown || item.dropDownMenu) && curIndex !== index"
                  :style="{
                    color: curIndex == index ? '#D7000F' : '#000000',
                    'font-size': '12px',
                    'font-weight': '600',
                  }"
                ></i>
                <i
                  class="el-icon-arrow-up"
                  v-else-if="(item.isDropdown || item.dropDownMenu) && curIndex == index"
                  :style="{
                    color: curIndex == index ? '#D7000F' : '#000000',
                    'font-size': '12px',
                    'font-weight': '600',
                  }"
                ></i>
                <dl class="custom-menu" v-if="dropDownMenuShow(item)">
                  <dd :class="{'active': currentPath(itemChildMenu.path)}" v-for="itemChildMenu of item.children" :key="itemChildMenu.name" :title="itemChildMenu.name" @click.stop="handleClickChildMenu(itemChildMenu)">{{itemChildMenu.name}}</dd>
                </dl>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col
          v-if="
            this.$route.path !== '/login' &&
            this.$route.path !== '/register' &&
            this.$route.path !== '/forestPwd'
          "
          :span="5"
        >
          <div style="float: right">
            <div
              v-if="userName"
              style="display: flex; line-height: 64px; height: 64px"
            >
              <div
                class="fangdajing"
                style="
                  margin-right: 15px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                @click="
                  (showSearch = true), (largesearch = true), (search = '')
                "
              >
                <img
                  style="width: 100%"
                  src="../assets/images/max.png"
                  alt=""
                />
              </div>
              <div
                @click="
                  (showSearch = true), (largesearch = true), (search = '')
                "
                class="searchbox"
                style="right: 270px"
                :class="minisearch ? 'minisearch' : ''"
                v-if="showSearch"
              >
                <div
                  @click="
                    (showSearch = true), (largesearch = true), (search = '')
                  "
                >
                  <el-input
                    @click="
                      addToHistory(search),
                        (showSearch = true),
                        (largesearch = true),
                        (search = '')
                    "
                    placeholder="关键词搜索"
                    v-model="search"
                    class="search"
                    style="
                      width: 315px;
                      background-color: #fff !important;
                      margin-right: 6px;
                      margin-top: 11px;
                      border: 1px solid #e8ebf3;
                    "
                    @keyup.enter.native="inputSearch"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="inputSearch"
                    ></el-button>
                  </el-input>
                  <div
                    style="
                      width: 1px;
                      height: 20px;
                      background: #999;
                      position: absolute;
                      top: 22px;
                      left: 26px;
                    "
                  ></div>
                </div>
                <div class="searchs">
                  <span
                    @click="
                      () => {
                        search = '';
                        showSearch = false;
                      }
                    "
                  >
                    <img src="../assets/images/close.png" alt="" />
                  </span>
                </div>
                <div class="hotpot">
                  <p class="title">热点搜索</p>
                  <div class="potbox">
                    <ul>
                      <li
                        v-for="(item, index) in hotpotlist"
                        :key="index"
                        @click="gosearch(item), addToHistory(item)"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                  <div class="search-history">
                    <p class="title" style="margin-top: 20px">搜索历史</p>
                    <div class="potbox">
                      <ul>
                        <li
                          v-for="(query, index) in historylist"
                          :key="index"
                          @click="gosearch(query)"
                        >
                          {{ query }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    style="text-align: center; color: #999; margin-top: 15px"
                  >
                    <span style="cursor: pointer" @click="clearHistory"
                      >清空历史</span
                    >
                  </div>
                </div>
              </div>
              <div style="display: flex; align-items: center; width: 360px">
                <el-button type="primary" style="margin-right: 10px; cursor: pointer;" @click="handleExperience()">申请体验</el-button>
                <span class="console" @click="handleCommand('console')" style="">控制台</span>
                <span
                  style="color: #000; cursor: pointer; margin-right: 25px"
                  @click="handleHelp"
                  >帮助</span
                >
                <div style="width: 110px">
                  <el-dropdown @command="handleCommand">
                    <span style="color: #000000; cursor: pointer">
                      <i class="el-icon-user-solid" style="font-size: 14px"></i>
                      <span style="font-size: 14px">{{
                        usernameInit(userName)
                      }}</span>
                      <i
                        class="el-icon-arrow-down el-icon--right"
                        style="font-size: 14px"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="info" icon="el-icon-user"
                        >个人信息</el-dropdown-item
                      >
                      <el-dropdown-item
                        command="resetPhone"
                        icon="el-icon-document-checked"
                        >修改绑定手机</el-dropdown-item
                      >
                      <el-dropdown-item command="reset" icon="el-icon-lock"
                        >修改密码</el-dropdown-item
                      >
                      <el-dropdown-item
                        command="logout"
                        icon="el-icon-switch-button"
                        >退出登录</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>


            <div v-else style="display: flex; line-height: 64px; height: 64px">
              <div
                class="fangdajing"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                @click="
                  (showSearch = true), (largesearch = true), (search = '')
                "
              >
                <img
                  style="width: 100%"
                  src="../assets/images/max.png"
                  alt=""
                />
              </div>
              <div
                @click="
                  (showSearch = true), (largesearch = true), (search = '')
                "
                class="searchbox"
                :class="minisearch ? 'minisearch' : ''"
                v-if="showSearch"
              >
                <div
                  @click="
                    (showSearch = true), (largesearch = true), (search = '')
                  "
                >
                  <el-input
                    @click="
                      addToHistory(search),
                        (showSearch = true),
                        (largesearch = true),
                        (search = '')
                    "
                    placeholder="关键词搜索"
                    v-model="search"
                    class="search"
                    style="
                      width: 315px;
                      background-color: #fff !important;
                      margin-right: 6px;
                      margin-top: 11px;
                      border: 1px solid #e8ebf3;
                    "
                    @keyup.enter.native="inputSearch"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="inputSearch"
                    ></el-button>
                  </el-input>
                  <div
                    style="
                      width: 1px;
                      height: 20px;
                      background: #999;
                      position: absolute;
                      top: 22px;
                      left: 26px;
                    "
                  ></div>
                </div>
                <div class="searchs">
                  <span
                    @click="
                      () => {
                        search = '';
                        showSearch = false;
                      }
                    "
                  >
                    <img src="../assets/images/close.png" alt="" />
                  </span>
                </div>
                <div class="hotpot">
                  <p class="title">热点搜索</p>
                  <div class="potbox">
                    <ul>
                      <li
                        v-for="(item, index) in hotpotlist"
                        :key="index"
                        @click="gosearch(item), addToHistory(item)"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                  <div class="search-history">
                    <p class="title" style="margin-top: 20px">搜索历史</p>
                    <div class="potbox">
                      <ul>
                        <li
                          v-for="(query, index) in historylist"
                          :key="index"
                          @click="gosearch(query)"
                        >
                          {{ query }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    style="text-align: center; color: #999; margin-top: 15px"
                  >
                    <span style="cursor: pointer" @click="clearHistory"
                      >清空历史</span
                    >
                  </div>
                </div>
              </div>
              <div style="align-items: center; width: 300px; margin-left: 20px">
                <el-button type="primary" style="margin-right: 10px; cursor: pointer;"  @click="handleExperience()">申请体验</el-button>
                <span class="console" @click="handleCommand('console')">控制台</span>
                <span style="color: #000; cursor: pointer" @click="handleHelp">帮助</span>
                <router-link to="/login">
                  <div class="text register">登录/注册</div>
                </router-link>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="position: relative" v-if="$store.state.app.device == 'desktop'">
      <transition name="el-zoom-in-top">
        <div
          class="drawer"
          style="height: 600px"
          v-if="visible"
          @mouseleave="handleDrawerLeaver"
        >
          <!-- <div v-if="visible && searchShow" class="serchBox">
            <el-autocomplete class="inline-input" v-model="searchVal" :fetch-suggestions="querySearch"
              placeholder="搜索产品" :trigger-on-focus="false" :popper-append-to-body="false" @select="handleSelectTwo">
              <i class="el-icon-search" slot="suffix"></i>
              <template #default="{ item }">
                <div class="autocomplete-item">
                  <div class="autocomplete-item__value">{{ item.value }}</div>
                  <div class="autocomplete-item__desc">{{ item.content }}</div>
                </div>
              </template>
</el-autocomplete>
</div> -->
          <div
            style="
              width: 1280px;
              margin: 0 auto;
              height: 100%;
              position: relative;
            "
          >
            <div class="drawer-left">
              <div
                v-for="(item, index) in list"
                :key="index"
                class="classification"
                :style="[{ color: index ? '' : '#E50009' }]"
                @click="handleClassClick(item, index), (handleShowAll = false)"
              >
                <div
                  :class="{ active: active == index }"
                  style="display: flex; justify-content: space-between"
                >
                  <!-- <img :src="item.columnIcon" width="14px" height="14px" alt="" v-if="item.columnIcon"
                  style="margin-bottom: -2px;" /> -->
                  <!-- <i :class="item.iconLeft"></i> -->
                  <span>{{ item.columnName }}</span>
                  <i
                    class="el-icon-arrow-right"
                    v-if="item.columnName"
                    style="position: relative; top: -5px"
                  ></i>
                </div>
              </div>
              <div class="bottom_title">
                <div
                  style="
                    color: #666;

                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom: 8px;
                    line-height: normal;
                  "
                >
                  产业赋能企业数字化转型
                </div>
                <div
                  style="
                    color: #d7000f;

                    font-size: 16px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                    letter-spacing: 0.8px;
                  "
                >
                  <img
                    src="../assets/images/Phone-call.png"
                    alt=""
                    style="width: 18px"
                  />
                  <span> 13305324949 </span>
                </div>
              </div>
            </div>
            <div class="drawer-right" v-if="list[active]">
              <div
                style="
                  width: 200px;
                  color: #333;

                  font-size: 20px;
                  font-style: normal;
                  font-weight: 600;
                  margin-left: 18px;
                  line-height: normal;
                "
                @click="handleShowAll = true"
              >
                <div
                  style="display: inline-block; cursor: pointer"
                  v-for="(item, index) in list"
                  :key="index"
                  @click="handleTo(item.title)"
                >
                  {{ item.title }}
                </div>

                <i class="el-icon-arrow-right" style="font-size: 18px"></i>
              </div>
              <div
                v-if="handleShowAll == false"
                style="display: flex; flex-flow: row wrap"
              >
                <div
                  v-for="(item, index) in list[active].childrenList.slice(0, 9)"
                  :key="index"
                  class="details"
                  @click="handleDetailsClick(item, index)"
                >
                  <div>{{ item.name }}</div>
                  <span>{{ item.content }}</span>
                </div>
              </div>
              <div v-else style="display: flex; flex-flow: row wrap">
                <div
                  v-for="(item, index) in list[active].childrenList"
                  :key="index"
                  class="details"
                  @click="handleDetailsClick(item, index)"
                >
                  <div>{{ item.name }}</div>
                  <span>{{ item.content }}</span>
                </div>
              </div>
            </div>
            <div>
              <i class="el-icon-close drawer-close" @click="visible = true"></i>
            </div>
          </div>
        </div>
      </transition>
      <div class="mask" v-if="visible"></div>
    </div>

    <div v-else>
      <el-row type="flex" justify="space-around" align="center">
        <el-col :span="4">
          <i
            class="el-icon-s-unfold"
            style="color: #ccc; font-size: 28px"
            @click="drawer = true"
          ></i>
        </el-col>
        <el-col :span="16">
          <div v-if="userName" style="text-align: right; color: #ccc">
            <i class="el-icon-user-solid" style="font-size: 16px"></i>
            <span style="font-size: 16px">{{ userName }}</span>
          </div>
          <div v-else>
            <router-link to="/login">
              <span style="float: right; font-size: 16px; color: #ccc"
                >登录</span
              >
            </router-link>
          </div>
        </el-col>
      </el-row>
      <el-drawer
        :show-close="false"
        :modal="false"
        :visible.sync="drawer"
        :withHeader="false"
        direction="ltr"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-menu
              :default-active="`${curIndex}`"
              mode="horizontal"
              active-text-color="#e74c3c"
              @select="handleSelect"
            >
              <el-menu-item
                :index="`${index}`"
                v-for="(item, index) in menuList"
                :key="index"
                >{{ item.name }}
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import eventBus from "../utils/eventBus";
import fish from "@/utils/fishkefu.js";
import {
  columnList,
  listProduct,
  detailCoBuilding,
  detailPromotion,
  listProductAll,
} from "@/api";
import { getUserInfo, getveriftToken } from "@/api/console";

export default {
  name: "Header",
  data() {
    return {
      cur: 0,
      hotProducts: [],
      menuLeftList: [
        {
          name: "热门推荐",
          title: {
            productTitle:[],
            productIntroduction:[]
          },
        },
        {
          name: "环卫产品",
          title: {
            productTitle:[1],
            productIntroduction:[]
          },
        },
        {
          name: "环保产品",
          title: {
            productTitle:[2],
            productIntroduction:[]
          },
        },
        {
          name: "通用产品",
          title: {
            productTitle:[3],
            productIntroduction:[]
          },
        },
        {
          name: "产品服务",
          title: {
            productTitle:[4],
            productIntroduction:[]
          },
        },
      ],
      chakan: "",
      open: false,
      // 手机模式菜单栏
      drawer: false,
      // 下拉导航
      visible: false,
      curIndex: 0,
      lastIndex: 0,
      active: 1,
      handleShowAll: false,
      menuList: [],
      list: [],
      search: "",
      showSearch: false,
      minisearch: true,
      partnerList: [],
      listProduct: [],
      historylist: [],
      hotpotlist: ["一网统管", "垃圾分类", "集团管控", "收运系统"],
      menuSearchList: [
        {
          value: "选项1",
          label: "选项1",
        },
      ],
      searchVal: "",
      restaurants: [],
      searchShow: false,
      menuHeader: [],
    };
  },
  computed: {
    ...mapGetters(["userName"]),
    dropDownMenuShow() {
      return function (item){
        return  item.dropDownMenu && item.activeMenu && item.hasOwnProperty('children') && Array.isArray(item.children) && item.children
      }
    },
    currentPath() {
      return function (path){
        if (path === '/industry-think-tank') {
          return ['/industry-think-tank', '/specialists-detail', '/business-directory-detail'].includes(this.$route.path)
        }
        if(path === '/replay') {
          return ['/replay', '/playDetail'].includes(this.$route.path)
        }
      }
    }
  },
  watch: {
    userName(newVal) {
      if (newVal) this.getProProduct();
    },
    $route(to, from) {
      this.drawer = false;
      this.visible = false;
      this.getCurIndex(to);
    },
    curIndex(newVal) {
      if (this.menuList[newVal].desc === "ecoPartner")
        this.list[1] = this.partnerList;
    },
  },
  beforeMount() {
    // console.log(object);
    fish.init();
  },
  created() {
    this.getlistProductAll();
    this.getColumn();
    if (this.userName) {
      this.getToken();
    }
  },
  mounted() {
    this.getlistProductAll();
    fish.config();
    eventBus.$on("closeSearch", (msg) => {
      // this.message = msg;
      // console.log(msg,'msgggg');
      if (msg) {
        this.search = "";
        this.showSearch = false;
      }
    });
  },

  methods: {
    handleClickChildMenu(item) {
      if (item.path && (item.path.indexOf('http') > -1 || item.path.indexOf('https') > -1)) {
        window.open(item.path);
      }else{
        this.$router.push(item.path);
      }
    },
    addToHistory(query) {
      // 添加搜索词到历史记录，去除重复项
      const history = [...new Set([...this.historylist, query])];
      this.historylist = history;
    },
    clearHistory() {
      this.historylist = [];
    },
    handleHelp() {
      this.$router.push({ path: "/Open" });
    },
    getlistProductAll() {
      listProductAll().then((res) => {

        this.list.push(res.data[0].serviceList);
        if (res.data && res.data.length > 1 && Array.isArray(res.data[1].serviceList)
        ) {
          res.data[1].serviceList.forEach((item) => {
            if (item.categoryLabel === "热门产品" && !this.hotProducts.some((p) => p.id === item.id)) {
              this.hotProducts.push(item);
              this.menuLeftList[0].title.productTitle.push(item.productTitle);
              this.menuLeftList[0].title.productIntroduction.push(item.productIntroduction);
            }
          });
        }
      });
    },
    getProProduct() {
      getUserInfo().then((res) => {
        this.listProduct = res.data.pList.map((item) => {
          const arr = String(item.remark).split("@@");
          item.url = arr[0];
          item.desc = arr[1];
          return item;
        });
      });
    },
    usernameInit(name) {
      if (name.length > 5) {
        return name.substring(0, 4) + "...";
      } else {
        return name;
      }
    },
    // 获取生态伙伴数据
    async getPartnerList() {
      const list = [
        {
          name: "生态伙伴",
          path: "/EcoPartner",
          content: "指导单位，共建单位介绍，以及共建历程及原则。",
          homepageDisplay: "1",
        },
      ];
      const res1 = detailCoBuilding().then((res) => {
        list.push({
          name: res.data.principleTitle,
          path: "/EcosystemJoint?name=coBuilding",
          content: res.data.principleContent,
          homepageDisplay: "1",
        });
      });
      const res2 = detailPromotion().then((res) => {
        list.push({
          name: res.data.principleTitle,
          path: "/EcosystemJoint?name=promotion",
          content: res.data.principleContent,
          homepageDisplay: "1",
        });
      });
      const data = await Promise.all([res1, res2]);

      // data.forEach(v => {
      //   if()
      //   list.push({ name: v.data.principleTitle, path: "/EcosystemJoint", content: v.data.principleContent })
      // })

      this.partnerList = { childrenList: list };
    },
    //查询当前登录token是否有效
    async getToken() {
      const data = await getveriftToken();
      if (data.msg == 0) {
        console.log("token失效,清登录信息");
        this.quit();
      }
    },
    handleTo(title) {
      if (title == "全部产品服务") {
        this.$router.push({ path: "/ProductService" });
      } else {
        this.$router.push({ path: "/Solution" });
      }
    },
    gosearch(item) {
      this.$router.push({
        path: "/search",
        query: {
          searchcontent: item,
        },
      }),
        (this.showSearch = false);
    },

    //搜索
    inputSearch() {
      if (this.search != "") {
        this.$router.push({
          path: "/search",
          query: {
            searchcontent: this.search,
          },
        });
        this.showSearch = false;
        this.addToHistory(this.search);

        // this.minisearch = true;
        // const that = this
        // setTimeout(() => {
        // that.minisearch = true;
        // console.log(that,'that');
        // }, 300)
      }
    },

    // 获取项目数据
    async getItem(id, key) {
      const res = await listProduct({ id });
      this.menuList[key[0]].children[key[1]].children = res.rows;
    },
    // 获取菜单数据
    async getColumn() {
      const res = await columnList({ useFlag: "1" });
      const data = res.rows;
      this.menuHeader = res.rows;
      this.restaurants = this.loadAll(res.rows[1].children);

      // 生成导航配置
      const menuList = [];
      /**
       *映射规则 --  home: '首页', productService: '产品服务', solution: '解决方案', ecoPartner: '生态伙伴', appMarket: '应用市场', information: '平台资讯', aboutUs: '关于平台'
       */
      data.forEach((v, i) => {
        switch (v.desc) {
          case "home":
            menuList.push({
              ...v,
              name: "首 页",
              path: "/",
              isDropdown: false,
            });
            break;
          case "productService":
            {
              const children = this.handleProductList(v.children); // 处理子列表数据
              menuList.push({
                ...v,
                name: "产品服务",
                path: "/ProductService",
                isDropdown: true,
                children,
              });
            }
            break;
          case "solution":
            {
              const children = this.handleSolution(v.children); // 处理子列表数据
              menuList.push({
                ...v,
                name: "解决方案",
                path: "/Solution",
                isDropdown: true,
                children,
              });
            }
            break;
          case "typicalCase":
            {
              const children = this.handleEcoPartner(v.children); // 处理子列表数据
              menuList.push({
                ...v,
                name: "典型案例",
                path: "/TypicalCase",
                isDropdown: false,
                children,
              });
            }
            break;
          case "ecoPartner":
            {
              const children = this.handleEcoPartner(v.children); // 处理子列表数据
              menuList.push({
                ...v,
                name: "生态伙伴",
                path: "/EcoPartner",
                isDropdown: false,
                children,
              });
            }
            break;
          // case "openPlatform":
          //   menuList.push({
          //     ...v,
          //     name: "开放平台",
          //     path: "/Open",
          //     isDropdown: false,
          //   });
          //   break;
          case "information":
            menuList.push({
              ...v,
              name: "平台资讯",
              path: "/Information",
              isDropdown: false,
            });
            break;
          case "aboutUs":
            menuList.push({
              ...v,
              name: "关于平台",
              path: "/AboutUs",
              isDropdown: false,
            });
            break;
          case "appMarket":
            menuList.push({
              ...v,
              name: "应用市场",
              path: "/Applicationmarket",
              isDropdown: false,
            });
            break;
          case "envirLive":
            const children = [{
              name: 'E 速递',
              path: 'https://pachong.eiiplat.com/'
            }, {
              name: 'E 智库',
              path: '/industry-think-tank'
            }, {
              name: 'E 社群',
              path: '/replay'
            }];
            menuList.push({
              ...v,
              name: "E 智汇",
              isDropdown: false,
              dropDownMenu: true,
              activeMenu: false,
              children
            });
            break;
        }
      });
      this.menuList = menuList;
      this.getCurIndex(this.$route);
    },

    // 处理产品服务自定义子项
    handleProductList(data) {
      // 添加默认item
      if (data.length) {
        const index = data.findIndex(
          (v) => v.desc === "environmentalSanitation"
        ); //环卫产品
        if (index !== -1)
          data[index].childrenList.push({
            name: "天人厌氧子平台",
            path: "/AnSubPlatform?id=0",
            content: "项目设计-设备采购-财务税收-项目施工-原料收运-生产管控",
          });
      }

      const productList = [
        {
          title: "全部产品服务",
          // columnName: "热门推荐",
          iconLeft: "el-icon-menu",
          iconRight: "el-icon-arrow-right",
          path: "/ProductService",
        },
        ...data,
      ];
      return productList;
    },
    // 处理解决方案自定义子项
    handleSolution(data) {
      const solution = [
        {
          title: "全部解决方案",
          // columnName: "全部方案",
          iconLeft: "el-icon-menu",
          iconRight: "el-icon-arrow-right",
          path: "/Solution",
          children: [],
        },
        ...data,
      ];
      return solution;
    },
    // 处理生态伙伴自定义子项
    handleEcoPartner(data) {
      // data.push({ childrenList: [{ name: '天人厌氧子平台', path: '/AnSubPlatform?id=0', content: '项目设计-设备采购-财务税收-项目施工-原料收运-生产管控' }] })
      const ecoPartner = [
        {
          columnName: "生态伙伴",
          iconLeft: "el-icon-menu",
          iconRight: "el-icon-arrow-right",
          path: "/EcoPartner",
          children: [],
        },
        ...data,
      ];
      return ecoPartner;
    },

    ...mapActions({
      quit: "logout",
    }),
    handleSelect(index) {
      this.handleMenuClick(this.menuList[index], index);
    },
    handleMenuClick(item, index) {
      //页面跳转
      // if (item.desc === 'appMarket') {
      //   this.curIndex = this.lastIndex
      //   window.open(`http://app.eiiplat.com/#/index?userName=${localStorage.userName}&token=${localStorage.usertoken}`)

      // } else
      //  if (item.desc === 'openPlatform') {
      //   this.curIndex = this.lastIndex
      //   // window.open(`http://open.eiiplat.com/`)
      // } else if (this.$route.path != item.path) {
      this.curIndex = index;
      this.lastIndex = index;
      this.$router.push({ path: item.path });
      // }
    },
    handleMenuEnter(item, index) {
      // 判断是不是下拉菜单
      if(item.dropDownMenu) {
        item.activeMenu=true
      }
      this.curIndex = index;
      this.restaurants = this.loadAll(this.menuHeader[index].children);
      this.searchShow = item.name === "产品服务" || item.name === "解决方案";
      if (item.isDropdown) {
        this.visible = true;
        this.active = 1;
        this.list = this.menuList[index].children;
      } else {
        this.visible = false;
      }
    },
    handleMenuLeave(item) {
      setTimeout(() => {
        if(item.dropDownMenu) {
          item.activeMenu=false
        }
        if (!item.isDropdown) {
          this.visible = false;
          this.curIndex = this.lastIndex;
        }
      }, 300)
    },
    handleDrawerLeaver() {
      this.visible = false;
      this.searchVal = "";
      this.curIndex = this.lastIndex;
    },
    handleClassClick(item, index) {
      if (index) {
        this.active = index;
      } else {
        this.$router.push({ path: item.path });
      }
    },
    handleDetailsClick(item, index) {
      if (item.homepageDisplay !== "1") return;

      let path = "";
      switch (this.menuList[this.curIndex].desc) {
        case "productService":
          path = "/ProductDetails";
          break;
        case "solution":
          path = "/SolutionDetails";
      }

      this.$router.push({
        path: item.path || path,
        query: { id: item.id, index: this.curIndex },
      });
    },
    handleExperience(){
      this.$router.push({ path: '/Applicationmarket' })
    },
    handleCommand(command) {
      if (command == "console") {
        this.$router.push({ path: "/console" });
      } else if (command == "reset") {
        this.$router.push({ path: "/resetPWD" });
      } else if (command == "info") {
        //个人信息
        this.$router.push({ path: "/userInfo" });
      } else if (command == "resetPhone") {
        //修改绑定手机
        this.$router.push({ path: "/resetPhoneNumber" });
      } else {
        this.$router.replace({ path: "/login" });
        this.quit();
      }
    },
    handleGoTop() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let everyValue = scrollTop / 10;
      let i = 1;

      // document.documentElement.scrollTop = document.body.scrollTop = 0
      let timer = setInterval(() => {
        document.documentElement.scrollTop = document.body.scrollTop =
          scrollTop - everyValue * i;
        i++;
        if (i > 10) {
          clearInterval(timer);
        }
      }, 30);
    },
    handleGoConsult() {
      fish.open();
      // window.open('http://qiyukf.com/script/044865c94981c048609d5c94c1ae9c6d.js', "ukefu-chat", "height=600, width=850, top=" + (window.screen.availHeight - 30 - 600) / 2 + ", left=" + (window.screen.availWidth - 10 - 750) / 2 + ",toolbar=no, menubar=no, scrollbars=no, resizable=no, directories=no,location=no, status=no")
    },
    handleGoMessage() {
      this.open = true;
    },
    getCurIndex(to) {
      for (let i in this.menuList) {
        if (this.menuList[i].path == to.path) {
          this.curIndex = i;
          this.lastIndex = i;
          break;
        } else if (i == to.query.index) {
          this.curIndex = i;
          this.lastIndex = i;
          break;
        }
      }
    },
    cancle(data) {
      this.open = data;
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !==
          -1
        );
      };
    },
    loadAll(data) {
      let loadList = this.handleData(data).map((item) => {
        return {
          value: item.name,
          content: item.content,
          id: item.id,
          homepageDisplay: item.homepageDisplay,
        };
      });

      return loadList;
    },
    handleSelectTwo(item) {
      this.handleDetailsClick(item);
    },
    // 处理菜单数据铺平数组
    handleData(data) {
      return data
        .map((item) => {
          return [...item.childrenList];
        })
        .flat();
    },
  },
};
</script>

<style lang="scss">
.menu-list {
  border-top: 1px solid #d7000f;
  background: #fff;
  height: 600px;
  position: absolute;
  top: 64px;
  left: 0;
  width: 100%;
}
// .searchbox{
//   height: 95px;
//     position: absolute;
//     -webkit-transition: all 1s;
//     transition: all 1s;
//     top: 64px;
//     width: 365px;
//     .hotpot{
//       width: 100%;
//     height: 96px;
//     line-height: 20px;
//     position: absolute;
//     top: 10px;
//     }
//     .searchs{
//       position: relative;
//     left: 319px
// px
// ;
//     top: -16px;
//     }
// }
.el-col-md-3:first-of-type {
  width: 7% !important;
}
.el-col-md-3:nth-of-type(5) {
  width: 11.5% !important;
}
@media screen and (max-width: 1510px) {
  .head-container .logo {
    width: 13rem !important;
  }
  .el-col-md-3 {
    width: 11%;
    > div > span {
      font-size: 12px !important;
    }
  }
}
@media screen and (max-width: 1580px) {
  .head-container .logo {
    width: 14rem !important;
  }
  .el-col-md-3 {
    width: 11%;
    > div > span {
      font-size: 12px !important;
    }
  }
}
@media screen and (max-width: 1258px) {
  .head-container .logo {
    width: 12rem !important;
  }
}
.el-col-md-3 {
  width: 11%;
  > div > span {
    // font-size: 14px !important;
  }
}
.product-list {
  width: 100%;
  background: #ffffff;
  padding: 5px 15px;
  box-sizing: border-box;

  .box {
    height: 75px;
    background: #ffffff;
    border: 1px solid #e8ebf3;
    margin-top: 20px;
    cursor: pointer;
    padding: 10px;
    box-sizing: border-box;

    .title {
      font-size: 14px;
      font-weight: 400;
      height: 22px;
      // margin-bottom: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .desc {
      font-size: 12px;
      font-weight: 400;
      color: rgba(19, 20, 21, 0.7);
      height: 17px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover .title {
      color: #e50009;
    }
  }
}

.popover-item {
  padding: 10px;
  cursor: pointer;

  .h1 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .h2 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.7);
  }

  .h3 {
    font-size: 12px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.7);
  }

  &:hover .h1 {
    color: #e50009;
  }
}

.head-container {
  width: 100%;
  height: 64px;
  line-height: 64px;
  background: #fff;
  position: fixed;
  z-index: 1600;
  // font-family: -apple-system-font, PingFang SC, Helvetica Neue, Helvetica,
  //   STHeiTi, sans-serif;

  .searchbox {
    background-color: #fff;
    padding: 0 16px;
    height: 95px;
    position: absolute;
    -webkit-transition: all 1s;
    transition: all 1s;
    top: 0;
    border-radius: 4px;
    width: 365px;
    right: 200px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04),
      0px 0px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.04);

    .searchs {
      position: absolute;
      left: 335px;
      top: 0px;
      span {
        line-height: 20px;
        cursor: pointer;
        width: 20px;
        height: 20px;
        display: inline-block;
        img {
          width: 100%;
        }
      }
    }

    &.minisearch {
      // height: 320px;
      height: auto;
      transition: all 1s;
    }

    .hotpot {
      // width: 100%;
      // height: 96px;
      line-height: 20px;
      padding: 10px 0;
      // position: absolute;
      // top: 10px;

      .title {
        color: #999;
        margin-bottom: 8px;
      }

      .potbox {
        margin: 0;
        padding: 0;

        ul {
          margin: 0;
          padding: 0;
          list-style: none;

          li {
            display: inline-block;
            color: #333;
            cursor: pointer;
            border: 1px solid #ddd;
            padding: 5px 9px;
            background-color: #f2f3f5;
            margin: 5px 7px 5px 0;
          }
        }
      }
    }
  }

  .search {
    background-color: #fff !important;
    .el-input__inner {
      border-right: none !important;
      border-radius: 0px;
      color: #333 !important;
      background: #f2f3f5;
      &:focus {
        border: 1px solid #dcdfe6;
      }
    }

    .el-input-group__append {
      border-left: none;
      border-radius: 0px;
      overflow: hidden;
    }

    .el-button {
      background-color: #f2f3f5 !important;
      border: none;
      height: 100%;
      border-radius: 0px 4px 4px 0;
      .el-icon-search {
        font-size: 18px;
      }
    }
  }

  .suspend-box {
    display: inline-block;
    position: fixed;
    right: 10px;
    bottom: 20%;

    .contact-btn {
      width: 46px;
      height: 148px;
      line-height: 20px;
      padding: 15px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #f3f4f6;
      border-radius: 50px;
      cursor: pointer;

      span {
        font-size: 14px;
        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC-Regular;
        color: rgba(19, 20, 21, 0.7);
      }

      i {
        color: #d7000f;
        font-size: 18px;
        margin-top: 5px;
      }
    }
  }

  .logo {
    width: 18rem;
    // height:45%;
    margin-left: 0.2rem;
    vertical-align: middle;
    cursor: pointer;
  }

  .text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #000000;
    cursor: pointer;
  }

  .login {
    width: 28px;
    height: 20px;
    margin-right: 10px;
  }

  .login:hover {
    color: #d7000f;
  }

  .register {
    width: 105px;
    height: 64px;
    color: #fff;
    line-height: 64px;
    text-align: center;
    background: #d7000f;
    top: 0;
    right: -51px;
    position: absolute;
  }

  .drawer {
    width: 100%;
    height: 500px;
    position: fixed;
    padding: 0 300px;
    top: 64px;
    left: 0;
    z-index: 2000;
    box-sizing: border-box;
    border-top: 1px solid #d7000f;
    // background: #fff;
    background: #ffffff;
    // box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.04),
      0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 16px 24px 0px rgba(0, 0, 0, 0.04),
      0px 24px 32px 0px rgba(0, 0, 0, 0.04);

    .drawer-close {
      position: absolute;
      cursor: pointer;
      top: 20px;
      right: -280px;
    }

    .drawer-left:first-child {
      padding-top: 10px;
      box-sizing: border-box;
    }

    .drawer-left {
      display: inline-block;
      width: 20%;
      height: 1%;
      position: absolute;
      top: 0;
      left: -125px;
      font-size: 18px;
      font-weight: 400;

      .bottom_title {
        position: absolute;
        top: 390px;
        left: 130px;
        width: 145px;
      }

      .classification {
        display: flex;
        cursor: pointer;
        height: 10%;
        margin-bottom: 50px;

        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0em;
        text-align: left;
        flex-direction: column;
        align-items: flex-end;
        line-height: 0.35rem;
        cursor: pointer;

        div {
          display: inline-block;
          width: 50%;
          padding-left: 10px;

          color: #333;
        }

        .active {
          color: #e50009 !important;
          background: #fff;
        }
      }
    }

    .drawer-right::-webkit-scrollbar {
      display: none;
    }

    .drawer-right {
      display: inline-block;
      background: #fff;
      width: 78%;
      height: 100%;
      position: absolute;
      padding-top: 50px;
      padding-left: 40px;
      top: 0;
      left: 22%;
      overflow: auto;
      border-left: 1px solid #e5e5e5;
      .details {
        height: 124px;
        padding: 24px 20px;
        width: 278px;
        // margin-left: 20px;
        box-sizing: border-box;
        flex: 0 0 33%;
        // margin-top: 20px;
        display: inline-block;
        line-height: 16px;
        cursor: pointer;

        div {
          color: #333;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 22.5px;
          /* 140.625% */
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 5px !important;
        }

        span {
          color: #666;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          -webkit-line-clamp: 2 !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          white-space: normal !important;
          /* 171.429% */
          display: inline-block;
          vertical-align: top;
          line-height: 20px;
        }
      }

      .details:hover div {
        color: #fb4c58;
      }

      // .details div {
      //   height: 20px;
      //   font-size: 14px;
      //   font-weight: 500;
      //   color: #131415;
      //   margin: 0;
      // }

      // .details span {
      //   font-size: 13px;
      //   font-weight: 400;
      //   word-wrap: break-word;
      //   color: rgba(19, 20, 21, 0.40);
      // }
    }
  }

  .mask {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    // background: rgba(0, 0, 0, 0.3);
  }

  .serchBox {
    position: fixed;
    z-index: 2000;
    width: 100%;
    height: 30px;
    margin-top: -5px;
    left: 170px;
  }

  .el-autocomplete-suggestion li:hover {
    color: red;
  }

  .autocomplete-item__value {
    width: 100%;
    height: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }

  .autocomplete-item__desc {
    width: 100%;
    height: 100%;
    font-size: 10px;
    color: rgba(19, 20, 21, 0.4);
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .console {
    margin-right: 30px;
    font-size: 14px;
    color: #000000;
    cursor: pointer;

    &:hover {
      color: #e50009;
    }
  }

  .experience {
    margin-right: 30px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      color: #e50009;
    }
  }
}

.custom-menu{
  list-style-type: none;
  width: 100%;
  margin: 0;
  padding: 0;
  background: #ffffff !important;
  border-top: 1px solid #e50009;
  box-shadow:
    -5px 0 5px -3px rgba(0, 0, 0, 0.1), /* 左边阴影 */
    5px 5px 5px -3px rgba(0, 0, 0, 0.1), /* 右下角阴影 */
    -5px 5px 5px -3px rgba(0, 0, 0, 0.1); /* 下边阴影 */

  dd{
    background: #ffffff;
    font-size: 14px !important;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    padding: 0 10px;
    cursor: pointer;
    &.active{
      color: #D7000F;
      background-color: #f9f9f9;
    }
    &:hover{
      color: #D7000F;
      background-color: #f9f9f9;
    }
  }
}
</style>
<style lang="scss">
.el-dropdown-menu{
  width: 145px;
  .el-dropdown-menu__item{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue